<template>
  <v-layout>
    <v-flex
      shrink
      mr-3
      mt-2
    >
      <v-icon
        color="sz_red"
        large
      >
        warning
      </v-icon>
    </v-flex>
    <v-flex class="f-16">
      <p class="mb-2">
        {{ $t('manage_swr.modal.content.incorrect.file') }}
      </p>
      <p class="mb-2">
        {{ $t('manage_swr.modal.content.incorrect.data') }}
      </p>
      <v-divider
        v-if="responseCodeText"
        class="my-2"
      />
      <p
        v-if="responseCodeText"
        class="mb-0"
      >
        {{ $t('manage_swr.modal.content.incorrect.status_code') }}
      </p>
      <p v-if="responseCodeText">
        {{ responseCodeText }}
      </p>
      <div v-if="type === csvTypes.WAREHOUSE_FAMILIES && fileExists">
        <v-divider class="my-3" />
        <p class="mb-2 f-16">
          {{ $t('manage_swr.modal.content.verify.incorrect') }}
        </p>
        <a
          :href="response.result_filename"
          download
        >
          {{ fileName }}
        </a>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import csvTypes from '@/constants/csvTypes';
export default {
    name: 'VerifyModalIncorrect',
    props: {
        type: {
            type: String,
            required: true
        },
        response: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            csvTypes
        };
    },
    computed: {
        fileName () {
            return this.response.result_filename.replace(/^.*[\\/]/, '');
        },
        responseCodeText () {
            if (this.response && this.response.responseCode != null) {
                switch (this.response.responseCode) {
                case 'E1101':
                    return this.$t('manage_swr.modal.content.incorrect.code_text.1');
                case 'E1106':
                    return this.$t('manage_swr.modal.content.incorrect.code_text.2');
                default:
                    return this.response.responseCode;
                }
            }
            return null;
        },
        fileExists () {
            return this.response && this.response.result_filename;
        }
    }
};
</script>

<style scoped></style>
